export default defineI18nConfig(() => ({
  locale: 'tr',
  fallbackLocale: 'en',
  missingWarn: false,
  fallbackWarn: false
}))
